import { baseApi } from "../baseApi";

export const subCategoryApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    createSubCategory: builder.mutation({
      query: (formData) => ({
        url: "/sub-category-create",
        method: "POST",
        body: formData,
      }),

      invalidatesTags: ["SubCategory"],
    }),
    
    getSubCategories: builder.query({
      query: ({ page = 1,limit = 10,search = "",status = "",}={}) => 
        `/sub-category-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: ["SubCategory"],
    }),

    getSubCategoryById: builder.query({
      query: (id) => ({
        url: `/sub-category-view/${id}`,
        method: "GET",
      }),
      providesTags: ["SubCategory"],
    }),
    getSubCategoriesByCategory: builder.query({
      query: (categoryId) =>
        `/categories/${categoryId}/subcategories`,
      providesTags: ["SubCategory"],
    }),
  updateSubCategory: builder.mutation({
  query: ({ id, data }) => ({
    url: "/sub-category-update",
    method: "POST",
    body: {
      ...data,
      id,
    },
  }),

  invalidatesTags: ["SubCategory"],
}),
    changeStatusSubCategory: builder.mutation({
      query: (id) => ({
        url: `/sub-category-status/${id}`,
        method: "GET",
      }),
      invalidatesTags: ["SubCategory"],
    }),
    
    deleteSubCategory: builder.mutation({
      query: (data) => ({
        url: `/sub-category-delete`,
        method: "DELETE",
        body: data
      }),

      invalidatesTags: ["SubCategory"],
    }),
  }),
});

export const { useCreateSubCategoryMutation, useGetSubCategoriesQuery, useGetSubCategoryByIdQuery, useGetSubCategoriesByCategoryQuery, useUpdateSubCategoryMutation,
  useDeleteSubCategoryMutation,
} = subCategoryApi;